// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__1KowC","content":"LayoutSettings_content__3Gr-5"};